import * as _ from "lodash";
import { ViewerUtils } from "../common/viewerUtils";

import { PropertyModel as Model } from "../model/propertyFinder";
import { IModelNode, ModelNode } from "../smartDrawings";

export interface ISdDebugApi {
    getSelectedInfoToClipboard(extraInfo: string);
    errorMessage: string;
}

export class SdDebugApi implements ISdDebugApi {
    #forgeViewer: Autodesk.Viewing.GuiViewer3D;
    errorMessage: string;

    constructor(viewer: Autodesk.Viewing.GuiViewer3D) {
        this.#forgeViewer = viewer;
        this.errorMessage = "";
    }

    getSelectedInfoToClipboard(extraInfo: string) {
        let info = "";

        this.#getSelectedInfo().then((res) => {
            if (res.length > 0) {
                info = res.join(`\t${extraInfo}\n`);
                info = info + `\t${extraInfo}`;
                console.log(info);

                setTimeout(async () => console.log(
                        await window.navigator.clipboard.writeText(info)),
                    2000);
                //navigator.clipboard.writeText(info).then(() => alert("Kopioitu leikepöydälle!")).catch(e => console.error(e));
            }
        }).catch(e => console.log(e));
    }

    async #getSelectedInfo() {
        const criterion: Model.PropertyCriterion[] = [
            {
                types: ["IFCBEAM"],
                typeSelectors: [],
                "properties": [
                    {
                        "displayCategory": "IFC",
                        "finalCategory": "General",
                        "displayNames": [
                            {
                                "original": "GLOBALID",
                                "final": "IFC-ID",
                                "formatter": null
                                //},
                                //{
                                //    "original": "NAME",
                                //    "final": "IFC-NAME",
                                //    "formatter": null
                            }
                        ],
                        //"summed": false
                    }
                    //{
                    //    "displayCategory": "Identity Data",
                    //    "finalCategory": "General",
                    //    "displayNames": [{
                    //        "original": "Mark",
                    //        "final": "Type-ID",
                    //        "formatter": null
                    //    }],
                    //    "summed": false
                    //}
                ]
            }
        ];

        let propertyFinder = new Model.PropertyFinder(this.#getPropertiesFromModel);

        const aggregateResult = this.#forgeViewer.getAggregateSelection();
        let info: string[] = [];
        for (let item of aggregateResult) {
            for (let dbId of item.selection) {
                let propertiesAndTitle = await propertyFinder.getNodeProperties(new ModelNode(item.model.id, dbId), [], criterion);
                let props = propertiesAndTitle.properties;
                if (props.length > 0) {
                    if (props[0] == undefined)
                        console.log(props);
                    else {
                        info.push(props[0].displayValue.toString());
                        //console.log(props[0].displayValue);
                    }
                }
            }
        }

        return info;
    }

    #getPropertiesFromModel = (modelNode: IModelNode): Promise<Autodesk.Viewing.Property[]> => {
        return new Promise((resolve, reject) => {
            let viewer = this.#forgeViewer;
            ViewerUtils.getModel(modelNode.modelId, viewer).getProperties(
                modelNode.nodeId,
                result => resolve(result.properties),
                error => reject(error));
        });
    }
}